/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-comment-textnodes */
import classnames from 'classnames';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  addCompany,
  addCompanyGroup,
  cancelAddCompany,
  cancelAddCompanyGroup,
  cancelAddEnterpriseGroup,
  cancelDeleteCompany,
  cancelDeleteEnterprise,
  cancelEditCompany,
  cancelEditCompanyGroup,
  cancelEditEnterpriseAdmin,
  deleteCompany,
  deleteCompanyGroup,
  filterCompanies,
  getAllCompanyGroups,
  getAllEnterpriseAdmins,
  getCompanies,
  onRecover,
  onRecoverCompanyGroup,
  setCompanyStatus,
  showAddCompany,
  showAddCompanyGroup,
  showAddEnterpriseGroup,
  showDeleteCompany,
  showDeleteEnterprise,
  showEditCompany,
  showEditCompanyGroup,
  showEditEnterpriseAdmin,
  updateCompany,
  updateCompanyGroup,
  updateEnterpriseAdmin,
  getAllCompaniesByGroupAction,
  addEnterpriseGroup,
} from '../actions/Companies';
import AddCompanyGroupModal from '../components/AddCompanyGroupModal';
import AddCompanyModal from '../components/AddCompanyModal';
import Breadcrumbs from '../components/Breadcrumb';
import CompaniesList from '../components/CompaniesList';
import CompanyAutocomplete from '../components/CompanyAutocomplete';
import CompanyGroupList from '../components/CompanyGroupList';
import DeleteCompanyModal from '../components/DeleteCompanyModal.js';
import EditCompanyGroupModal from '../components/EditCompanyGroupModal';
import EditCompanyModal from '../components/EditCompanyModal';
import SetLimitEntries from '../components/SetLimitEntries';
import WithUserData from '../HOC/withUserData';
import filterIcon from '../Res/Icon/filter.png';
import { ENG_LOCALE } from '../lib/constants';
import CustomModal from '../components/CustomModal';
import CompanyGroupManagement from '../components/Companies/CompanyGroupManagement';
import { addSystemLogs } from '../actions/SystemLogs';
import { getBoxCount } from '../actions/EpikBoxes';
import { toast } from 'react-toastify';
import EnterpriseAdminList from '../components/EnterpriseAdminList';
import EnterpriseGroupManagement from '../components/Companies/EnterpriseGroupManagement';
import AddEnterpriseGroupModal from '../components/AddEnterpriseGroupModal';
import DeleteEnterpriseModal from '../components/DeleteEnterpriseModal';
import { callApi } from '../lib/api/callApi.js';
import { getPermissionForComponent } from '../utils/permissionsUtils.js';

const companyFilterOptions = [
  { label: 'Customer ID', value: 'customerID' },
  { label: 'Group', value: 'groupName' },
  { label: 'Company Name', value: 'companyName' },
  { label: 'Type', value: 'companyType' },
];
const groupFilterOptions = [
  { label: 'Group Name', value: 'groupName' },
  { label: 'Management Company', value: 'managementCompany' },
];
const enterpriseFilterOptions = [
  { label: 'Enterprise Group Name', value: 'enterpriseGroupName' },
  { label: 'Management Company', value: 'managementCompany' },
  { label: 'Customer ID', value: 'customerID' },
];
const filterTypeOptions = [
  { label: 'All', value: '' },
  { label: 'Customer', value: 'retail' },
  { label: 'Channel Partner', value: 'agency' },
  { label: 'Wholesale Partner', value: 'reseller' },
  { label: 'Channel Customer', value: 'partner' },
  { label: 'Manufacturer', value: 'manufacturer' },
];

const INITIAL_STATE = {
  companiesData: null,
  companyGroupsData: null,
  enterprisesData: null,
  companyNames: null,
  companyGroupNames: null,
  isLoadingCompaniesData: false,
  isLoadingCompanyGroupsData: false,
  isLoadingEnterprisesData: false,
  activeCompanyTab: 'companyList',
  selectedFilter: '',
  filterValue: '',
  companyType: 'all',
  hardDelete: '',
  sort: {
    name: '',
    order: '',
  },
  page: 1,
  limit: 10,
  dbSort: {},
};

class Companies extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    this.state = INITIAL_STATE;
    // this.onDelete = this.onDelete.bind(this);
    // this.onSendFax =  this.onSendFax.bind(this);
    // this.onDownload = this.onDownload.bind(this);
  }

  async componentDidMount() {
    this.getCompanyNames();
    this.getCompanyGroupNames();

    this.getCompaniesData();
  }

  componentDidUpdate(_, prevState) {
    const {
      filterValue: prevFilterValue,
      page: prevPage,
      limit: prevLimit,
      sort: prevSort,
      activeCompanyTab: prevActiveCompanyTab,
    } = prevState;
    const {
      filterValue: currFilterValue,
      page: currPage,
      limit: currLimit,
      sort: currSort,
      activeCompanyTab: currActiveCompanyTab,
    } = this.state;

    if (
      prevFilterValue !== currFilterValue ||
      prevPage !== currPage ||
      prevLimit !== currLimit ||
      prevSort.name !== currSort.name ||
      prevSort.order !== currSort.order ||
      prevActiveCompanyTab !== currActiveCompanyTab
    ) {
      if (currActiveCompanyTab === 'companyList') this.getCompaniesData();
      if (currActiveCompanyTab === 'groupManagement') this.getGroupsData();
      if (currActiveCompanyTab === 'enterpriseManagement') this.getEnterprisesData();
    }
  }

  getSearchResultsByGroupName = async event => {
    if (event.value == null) {
      this.props.getCompanies(this.token, undefined, 'yes');
    }
    if (event.value === '') {
      await getCompanies(this.token, undefined, 'yes');
    } else if (event.value !== undefined && event.value !== null) {
      await this.props.getAllCompaniesByGroup(this.token, event.suggestion._id);
    }
  };

  selectedCompanyDetails = companyId => {
    const { companiesData } = this.state;
    const company = companiesData?.docs?.filter(company => company._id === companyId);
    return company[0];
  };

  getSelectedCompanyGroup = groupId => {
    const { companyGroupsData } = this.state;
    const companyGroup = companyGroupsData?.docs?.filter(companyGroup => companyGroup._id === groupId);
    return companyGroup[0];
  };

  selectedEnterpriseDetails = enterpriseId => {
    const { enterprisesData } = this.state;
    const enterprise = enterprisesData?.docs?.filter(
      enterprise => enterprise._id === enterpriseId,
    );
    return enterprise[0];
  };

  onConfirm = async () => {
    const { hardDelete } = this.state;
    const {
      deleteCompanyID,
      deleteCompanyGroup: deleteCompanyGroup_,
      addSystemLogs,
    } = this.props;

    const selectedCompanyGroup = this.getSelectedCompanyGroup(deleteCompanyID);

    if (selectedCompanyGroup?.managedDevices === 0) {
      const response = await deleteCompanyGroup_(this.token, deleteCompanyID, hardDelete);
      if (response) {
        const body = {
          actionType: 'system',
          description: `Company Group: ${selectedCompanyGroup.name} has been deleted`,
        };
        await addSystemLogs(this.token, body);
        this.getGroupsData();
      }
    } else {
      toast.error('Company still has Devices Assigned. Please delete the Assigned Devices first.');
    }
  };

  deleteCompany = async () => {
    const {
      deleteCompanyID,
      deleteCompany: deleteCompany_,
      addSystemLogs,
    } = this.props;
    const selectedCompany = this.selectedCompanyDetails(deleteCompanyID);
    await deleteCompany_(this.token, deleteCompanyID);
    const body = {
      actionType: 'system',
      description: `Company: ${selectedCompany.name} has been deleted`,
    };

    await addSystemLogs(this.token, body);
    await this.getCompaniesData()
    await this.getCompanyNames();
  };

  deleteEnterprise = async () => {
    const {
      deleteEnterpriseID,
      addSystemLogs,
      editEnterpriseGroup,
    } = this.props;

    const selectedEnterprise = this.selectedEnterpriseDetails(deleteEnterpriseID);

    const deleteBody = {
      _id: deleteEnterpriseID,
      isDeleted: true,
    };

    await editEnterpriseGroup(this.token, deleteBody);

    const body = {
      actionType: 'system',
      description: `Enterprise Admin: ${selectedEnterprise.name} has been deleted`,
    };

    await addSystemLogs(this.token, body);
    this.getEnterprisesData();
  };
  deleteCompanyGroup = async () => {
    const {
      deleteCompanyID,
      deleteCompanyGroup: deleteCompanyGroup_,
      addSystemLogs,
    } = this.props;
  
    const { hardDelete } = this.state;
  
    const selectedCompanyGroup = this.getSelectedCompanyGroup(deleteCompanyID);
  
    const response = await deleteCompanyGroup_(this.token, deleteCompanyID, hardDelete);
  
    if (!response) return;
  
    const actionWord = hardDelete === 'yes' ? 'deleted' : 'cleared';
  
    const body = {
      actionType: 'system',
      description: `Company Group: ${selectedCompanyGroup.name} has been ${actionWord}`,
    };
    await addSystemLogs(this.token, body);
    this.getGroupsData();
  };

  onDelete = async () => {
    const { modalData } = this.state;
    const isCompany = 'Company';
    if (modalData === isCompany) {
      this.deleteCompany();
    } else if (modalData === 'Enterprise Admin') {
      this.deleteEnterprise();
    }
    else if (modalData === 'Company Group') {
      this.deleteCompanyGroup();
    }
  };

  onAddCompany = async () => {
    const { addedCompany, addSystemLogs, addCompany, getCompanies } = this.props;
    const token = localStorage.getItem('jwtToken') || null;
    if (addedCompany['name']) {
      addedCompany['name'] = addedCompany['name'].trim();
    }
    await addCompany(token, addedCompany);
    const body = {
      actionType: 'system',
      description: `Company:${addedCompany.name} has been added`,
    };

    await addSystemLogs(this.token, body);
    await this.getCompaniesData()
    getCompanies(this.token, undefined, 'yes');
  };

  onAddCompanyGroup = async () => {
    const { addCompanyGroupChange } = this.props;
    const token = localStorage.getItem('jwtToken') || null;
    if (addCompanyGroupChange['name']) {
      addCompanyGroupChange['name'] = addCompanyGroupChange['name'].trim();
    }
    await this.props.addCompanyGroup(token, addCompanyGroupChange);
    this.getGroupsData();
  };

  onAddEnterpriseGroup = async () => {
    const { addEnterpriseGroupChange, addEnterpriseGroup } = this.props;
    const token = localStorage.getItem('jwtToken') || null;
    if (addEnterpriseGroupChange.name) {
      addEnterpriseGroupChange.name = addEnterpriseGroupChange.name.trim();
    }
    console.log('addEnterpriseGroupChange', addEnterpriseGroupChange);

    await addEnterpriseGroup(token, addEnterpriseGroupChange);
    this.getEnterprisesData();
  };

  editCompany = async () => {
    const { addedCompany, editCompanyData } = this.props;
    const token = localStorage.getItem('jwtToken') || null;
    const companyShortName =
      addedCompany?.companyShortName ?? editCompanyData?.companyShortName ?? '';
    if (String(companyShortName).length > 4) {
      toast.error('Company Short Name cannot be more than 4 characters');
      return;
    }
    if (addedCompany['name']) {
      addedCompany['name'] = addedCompany['name'].trim();
    }
    const updated = await this.props.editCompany(token, editCompanyData._id, {
      ...addedCompany,
      name: addedCompany?.name || editCompanyData['name'],
    });
    if (updated) {
      this.getCompaniesData();
    }
  };

  editCompanyGroup = async addCompanyGroupChange => {
    const { editCompanyGroupData } = this.props;
    const token = localStorage.getItem('jwtToken') || null;

    if (addCompanyGroupChange['name']) {
      addCompanyGroupChange['name'] = addCompanyGroupChange['name'].trim();
    }
    await this.props.editCompanyGroup(token, editCompanyGroupData._id, addCompanyGroupChange);
    this.getGroupsData();
  };

  editEnterpriseGroup = async addCompanyGroupChange => {
    const { editEnterpriseGroupData, editEnterpriseGroup } = this.props;

    const token = localStorage.getItem('jwtToken') || null;
    let { name } = addCompanyGroupChange;
    if (name) {
      name = name.trim();
    }

    const { company, ...rest } = addCompanyGroupChange;
    const body = {
      _id: editEnterpriseGroupData._id,
      ...rest,
    };

    await editEnterpriseGroup(token, body);
    this.getEnterprisesData();
  };

  onSetStatus = async (company, status) => {
    // Send complete company object like edit modal does
    // Extract permissions to top level as updateCompany expects them
    const companyData = {
      ...company,
      enabled: status,
      emailNotifications: company.emailNotifications !== undefined 
        ? company.emailNotifications 
        : (company.permissions?.emailNotifications !== undefined 
          ? company.permissions.emailNotifications 
          : false),
      showCallRecording: company.showCallRecording !== undefined 
        ? company.showCallRecording 
        : (company.permissions?.showCallRecording !== undefined 
          ? company.permissions.showCallRecording 
          : false),
      showFaxDownload: company.showFaxDownload !== undefined 
        ? company.showFaxDownload 
        : (company.permissions?.showFaxDownload !== undefined 
          ? company.permissions.showFaxDownload 
          : false),
    };
    await this.props.editCompany(this.token, company._id, companyData);
    this.getCompaniesData();
  };

  handleChangePagination = async page => {
    this.setState({page})
  };

  getPagination = () => {
    const { page, limit } = this.props.companiesList;
    const pagination = { page, limit };
    return pagination;
  };

  handleSetLimit = (limit) => {
    this.setState(prevState => ({ ...prevState, limit }));
  }

  filterByCompanyFn = async e => {
    const { getAllCompanies } = this.props;
    this.setState({ companyType: e.target.value.toLowerCase() });
    await getAllCompanies(this.token, undefined, undefined, e.target.value.toLowerCase());
  };

  onRecoverCompany = async e => {
    let res;
    if (this.state.modalData === 'Company') {
      res = await this.props.onRecover(this.token, e);
      if (res) {
        setTimeout(() => {
          this.getCompaniesData();
        }, 1000);
      }
    } else {
      res = await this.props.onRecoverCompanyGroup(this.token, e);
      if (res) {
        this.getGroupsData();
      }
    }
  };

  handleSort = async columnName => {
    const { name, order } = this.state.sort;

    let updatedName, updatedOrder;

    if (name !== columnName || !order) {
      updatedName = columnName;
      updatedOrder = 1;
    } else if (order === 1) {
      updatedName = columnName;
      updatedOrder = -1;
    } else if (order === -1) {
      updatedName = '';
      updatedOrder = '';
    }

    this.setState({ sort: { name: updatedName, order: updatedOrder } });
  };

  sortColumnByKey = array => {
    const { sort } = this.state;
    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(
        array,
        [
          el =>
            el[sortNameArr[0]] === undefined
              ? ''
              : el[sortNameArr[0]][sortNameArr[1]].toLowerCase(),
        ],
        [sort.order],
      );
    } else if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name]?.toLowerCase()], [sort.order]);
    } else if (sort.name.indexOf('{') !== -1) {
      const sortNameArr = sort.name.replace(/[\{\}']+/g, ' ').split(' ');
      return orderBy(
        array,
        [el => (el[sortNameArr[0]] > el[sortNameArr[1]] ? el[sortNameArr[0]] : el[sortNameArr[1]])],
        [sort.order],
      );
    } else {
      return orderBy(array, [el => el[sort.name]], [sort.order]);
    }
  };

  getCompaniesData = async () => {
    this.setState({ isLoadingCompaniesData: true });

    const { selectedFilter, filterValue, page, sort, limit } = this.state;
    let endpoint = `companies/query?page=${page}&limit=${limit}&getDeleted=${global.deleteMode}`;

    if (selectedFilter && filterValue) {
      endpoint = endpoint.concat(
        `&${selectedFilter}=${encodeURIComponent(filterValue)}`,
      );
    }

    if (sort.name) {
      endpoint = endpoint.concat(`&sortBy=${sort.name}&sortDirection=${sort.order}`)
    }

    const response = await callApi({
      endpoint,
      method: 'GET',
      isMyEpik: true
    });
    this.setState({ companiesData: response.data, isLoadingCompaniesData: false });
  };

  getGroupsData = async () => {
    this.setState({ isLoadingCompanyGroupsData: true });

    const { selectedFilter, filterValue, page, sort, limit } = this.state;
    const paginateOptions = JSON.stringify({ page, limit, sort });
    let endpoint = `companyGroups?paginateResult=true&paginateOptions=${paginateOptions}`;

    if (selectedFilter && filterValue) {
      endpoint = endpoint.concat(
        `&${selectedFilter}=${encodeURIComponent(filterValue)}`,
      );
    }

    const response = await callApi({
      endpoint,
      method: 'GET',
      isMyEpik: true
    });
    this.setState({ companyGroupsData: response.data, isLoadingCompanyGroupsData: false });
  }

  getEnterprisesData = async () => {
    this.setState({ isLoadingEnterprisesData: true });

    const { selectedFilter, filterValue, page, sort, limit } = this.state;
    let endpoint = `enterprise-group?page=${page}&limit=${limit}`;

    if (selectedFilter && filterValue) {
      endpoint = endpoint.concat(
        `&${selectedFilter}=${encodeURIComponent(filterValue)}`,
      );
    }

    if (sort.name) {
      endpoint = endpoint.concat(`&sortBy=${sort.name}&sortDirection=${sort.order}`);
    }

    const response = await callApi({
      endpoint,
      method: 'GET',
      isMyEpik: true
    });
    this.setState({ enterprisesData: response.data, isLoadingEnterprisesData: false });
  };

  getCompanyGroupNames = async () => {
    const endpoint = `companyGroups?paginateResult=false&getDeleted=false&onlyName=true`;
    const response = await callApi({
      endpoint,
      method: 'GET',
      isMyEpik: true
    });
    this.setState({ companyGroupNames: response.data.docs });
  }

  getCompanyNames = async () => {
    const endpoint = `companies/?disablePaginate=yes&type=all&getDeleted=${global.deleteMode}&onlyNames=true`;
    const response = await callApi({
      endpoint,
      method: 'GET',
      isMyEpik: true
    });
    this.setState({ companyNames: response.data.docs });
  }

  handleChangeFilterValue = (e) => {
    const value = e.value || e.target?.value;
    this.setState({ filterValue: value, page: 1 });
  }

  renderFilterTypes = () => {
    const { selectedFilter, filterValue, companyNames, companyGroupNames } = this.state;

    if (selectedFilter === 'companyName' || selectedFilter === 'managementCompany') {
      return (
        <CompanyAutocomplete
          placeholder="Filter"
          companies={companyNames}
          searchTerm={filterValue}
          onChange={this.handleChangeFilterValue}
        />
      );
    }

    if (selectedFilter === 'groupName') {
      return (
        <CompanyAutocomplete
          placeholder="Filter"
          companies={companyGroupNames}
          onChange={this.handleChangeFilterValue}
        />
      );
    }

    if (selectedFilter === 'companyType') {
      return (
        <Input
          type="select"
          style={{ maxWidth: '200px' }}
          onChange={this.handleChangeFilterValue}
        >
          <option disabled selected value>
            Select a type
          </option>
          {filterTypeOptions.map(el => (
            <option key={el.value} value={el.value}>
              {el.label}
            </option>
          ))}
        </Input>
      );
    }

    return (
      <Input
        type="text"
        value={filterValue}
        onChange={this.handleChangeFilterValue}
      />
    );
  };
  onEditPress = e => {
    this.props.showEditCompanyGroup(e);
    this.props.getCompanies(this.token, undefined, 'yes', 'all', false);
  };

  onEditEnterPrise = e => {
    this.props.showEditEnterpriseAdmin(e);
    this.props.getCompanies(this.token, undefined, 'yes', 'all', false);
  };

  onFilterChange = e => {
    this.setState({ selectedFilter: e.target.value, filterValue: '' });
  };

  getFilterOptions = () => {
    const { activeCompanyTab } = this.state;

    if (activeCompanyTab === 'companyList') {
      return companyFilterOptions;
    }

    if (activeCompanyTab === 'groupManagement') {
      return groupFilterOptions;
    }

    if (activeCompanyTab === 'enterpriseManagement') {
      return enterpriseFilterOptions;
    }

    return [];
  }

  setActiveTab = (tab) => {
    this.setState({
      activeCompanyTab: tab,
      selectedFilter: INITIAL_STATE.selectedFilter,
      filterValue: INITIAL_STATE.filterValue,
      sort: INITIAL_STATE.sort,
      page: INITIAL_STATE.page,
      limit: INITIAL_STATE.limit,
    });
  }

  render() {
    const { user, deleteMode, editCompanyGroupData } = this.props;
    const {
      companyNames,
      companiesData,
      companyGroupsData,
      enterprisesData,
      selectedFilter,
      sort,
      isLoadingCompaniesData,
      isLoadingCompanyGroupsData,
      isLoadingEnterprisesData
    } = this.state;
    const {
      docs: companiesList = [],
      page: companiesPage = 0,
      limit: companiesPageSize = 10,
      totalDocs: companiesTotalDocs = 0,
    } = companiesData || {};

    const {
      docs: companyGroupsList = [],
      page: companyGroupsPage = 0,
      limit: companyGroupsPageSize = 10,
      totalDocs: companyGroupsTotalDocs = 0,
    } = companyGroupsData || {};

    const {
      docs: enterprisesList,
      page: enterprisesPage = 0,
      limit: enterprisesPageSize = 10,
      totalDocs: enterprisesTotalDocs = 0,
    } = enterprisesData || {};

    return (
      <div>
        <div className="filter-section">
          <Row>
            <Col md={12} sm={12} >
              <Row className="d-flex justify-content-end">
                {user.role !== 'companyGroupManager' ? (
                  <Col md={2} className="float-right">
                    {(this.state.activeCompanyTab === 'companyList' && (
                      <Button
                        className="float-right"
                        onClick={this.props.showAddCompany}
                        color="primary"
                        id="new-company-btn"
                      >
                        New Company
                      </Button>
                    )) ||
                      (this.state.activeCompanyTab === 'enterpriseManagement' && (
                        <Button
                          className="float-right"
                          onClick={() => {
                            this.props.showAddEnterpriseGroup();
                            this.props.getCompanies(this.token, undefined, 'yes', 'all', false);
                          }}
                          color="primary"
                        >
                          New Enterprise
                        </Button>
                      )) || (
                        <Button
                          className="float-right"
                          onClick={() => {
                            this.props.showAddCompanyGroup();
                            this.props.getCompanies(this.token, undefined, 'yes', 'all', false);
                          }}
                          color="primary"
                          id="new-group"
                        >
                          New Group
                        </Button>
                      )}
                  </Col>
                ) : null}
                <Col md={4} className="select-limit">
                  {companyNames && (
                    <>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend" className="filter-icon-div">
                          <img src={filterIcon} className="filter-icon" alt="..." />
                        </InputGroupAddon>
                        <Input
                          type="select"
                          className="filter-append-dropdown"
                          onChange={this.onFilterChange}
                          id="filter-append-dropdown"
                        >
                          <option disabled selected={!selectedFilter} value>Select filter</option>
                          {this.getFilterOptions().map(el => (
                            <option key={el.value} value={el.value} id={`${el.value}`}>
                              {el.label}
                            </option>
                          ))}
                        </Input>
                      </InputGroup>
                      {this.renderFilterTypes()}
                      {/* {this.state.selectedFilter === 'By Company' ? (
                        <CompanyAutocomplete
                          placeholder="Filter"
                          companies={this.props.companies.docs}
                          onChange={this.textSearchFilter}
                        />
                      ) : this.state.selectedFilter === 'By Type' ? (
                        <Input
                          type="select"
                          style={{ maxWidth: '200px' }}
                          onChange={e => this.filterByCompanyFn(e)}
                        >
                          {filterTypeOptions.map(el => (
                            <option key={el} value={el}>
                              {el}
                            </option>
                          ))}
                        </Input>
                      ) : (
                        <CompanyAutocomplete
                          placeholder="Filter"
                          companies={this.props.companies.docs}
                          onChange={this.textSearchFilter}
                        />
                      )} */}
                    </>
                  )}
                </Col>
                {/* <Col md="3">
                  <SetLimitEntries onChange={this.handleSetLimit} />
                </Col> */}
              </Row>
            </Col>
          </Row>
        </div>
        <Container fluid style={{ margin: 0 }}>
          <div className="viewContainer" style={{ marginTop: '20px' }}>
            {user.role === 'superAdmin' ? (
              <ButtonGroup className="tab-group">
                <Button
                  className={classnames({ active: this.state.activeCompanyTab === 'companyList' })}
                  onClick={() => this.setActiveTab('companyList')}
                  id="Company-tab"
                >
                  Companies
                </Button>
                <Button
                  className={classnames({
                    active: this.state.activeCompanyTab === 'groupManagement',
                  })}
                  onClick={() => this.setActiveTab('groupManagement')}
                  id="group-management-tab"
                >
                  Group Management
                </Button>
                <Button
                  className={classnames({
                    active: this.state.activeCompanyTab === 'enterpriseManagement',
                  })}
                  onClick={() => this.setActiveTab('enterpriseManagement')}
                >
                  Enterprise Management
                </Button>
              </ButtonGroup>
            ) : null}

            <Row>
              <Col md="12">
                <TabContent activeTab={this.state.activeCompanyTab}>
                  <TabPane tabId="companyList">
                    <Row>
                      <Col md={12}>
                        <CompaniesList
                          onRecover={e => {
                            this.setState({ modalData: 'Company' }, () => {
                              this.onRecoverCompany(e);
                            });
                          }}
                          deleteMode={deleteMode}
                          user={user}
                          companies={companiesList}
                          disabledCompany={user.company._id}
                          onDelete={e => {
                            this.setState({ modalData: 'Company' }, () => {
                              this.props.showDeleteCompany(e);
                            });
                          }}
                          onEdit={this.props.showEditCompany}
                          onSetStatus={this.onSetStatus}
                          isLoading={isLoadingCompaniesData}
                          onSort={this.handleSort}
                          sortValue={sort}
                        />
                        <Row className="justify-content-md-center">
                          <SetLimitEntries onChange={this.handleSetLimit} />
                          <Pagination
                            locale={ENG_LOCALE}
                            className="pagination-container"
                            onChange={this.handleChangePagination}
                            current={companiesPage}
                            total={companiesTotalDocs}
                            pageSize={companiesPageSize}
                            showLessItems={true}
                            showTotal={(total, range) =>
                              `${range[0]} - ${range[1]} of ${total} items`
                            }
                          />
                        </Row>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeCompanyTab}>
                  <TabPane tabId="groupManagement">
                    <Row>
                      <Col md={12}>
                        <CompanyGroupList
                          onRecover={e => {
                            this.setState({ modalData: 'Company Group' }, () => {
                              this.onRecoverCompany(e);
                            });
                          }}
                          deleteMode={deleteMode}
                          user={user}
                          companies={companyGroupsList || []}
                          disabledCompany={user.company._id}
                          onDelete={e => {
                            this.setState({ modalData: 'Company Group' }, () => {
                              this.props.showDeleteCompany(e);
                            });
                          }}
                          onEdit={this.onEditPress}
                          onSetStatus={this.onSetStatus}
                          isLoading={isLoadingCompanyGroupsData}
                          onSort={this.handleSort}
                          sortValue={sort}
                        />
                        <Row className="justify-content-md-center">
                          <SetLimitEntries onChange={this.handleSetLimit} />
                        <Pagination
                          locale={ENG_LOCALE}
                          className="pagination-container"
                          onChange={this.handleChangePagination}
                          current={companyGroupsPage}
                          total={companyGroupsTotalDocs}
                          pageSize={companyGroupsPageSize}
                          showLessItems={true}
                          showTotal={(total, range) =>
                            `${range[0]} - ${range[1]} of ${total} items`
                          }
                        />
                        </Row>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeCompanyTab}>
                  <TabPane tabId="enterpriseManagement">
                    <Row>
                      <Col md={12}>
                        <EnterpriseAdminList
                          onRecover={e => {
                            this.setState({ modalData: 'Enterprise Admin' }, () => {
                              this.onRecoverCompany(e);
                            });
                          }}
                          deleteMode={deleteMode}
                          user={user}
                          companies={enterprisesList || []}
                          disabledCompany={user.company._id}
                          onDelete={e => {
                            this.setState({ modalData: 'Enterprise Admin' }, () => {
                              this.props.showDeleteEnterprise(e);
                            });
                          }}
                          onEdit={this.onEditEnterPrise}
                          onSetStatus={this.onSetStatus}
                          isLoading={isLoadingEnterprisesData}
                          onSort={this.handleSort}
                          sortValue={sort}
                        />
                        <Row className="justify-content-md-center">
                          <SetLimitEntries onChange={this.handleSetLimit} />
                          <Pagination
                          locale={ENG_LOCALE}
                          className="pagination-container"
                          onChange={this.handleChangePagination}
                          current={enterprisesPage}
                          total={enterprisesTotalDocs}
                          pageSize={enterprisesPageSize}
                          showLessItems={true}
                          showTotal={(total, range) =>
                            `${range[0]} - ${range[1]} of ${total} items`
                          }
                        />
                        </Row>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </div>
          <DeleteCompanyModal
            modalData={this.state.modalData}
            isOpen={this.props.deleteCompanyShow}
            onCancel={this.props.cancelDeleteCompany}
            onConfirm={hardDelete =>
              this.setState({ hardDelete }, () => {
                this.onDelete();
              })
            }
          />

          <DeleteEnterpriseModal
            modalData={this.state.modalData}
            isOpen={this.props.deleteEnterpriseShow}
            onCancel={this.props.cancelDeleteEnterprise}
            onConfirm={e => {
              this.setState({ hardDelete: e });
              this.onDelete();
            }}
          />

          <AddCompanyModal
            isOpen={this.props.addCompanyShow}
            onCancel={this.props.addCompanyCancel}
            onConfirm={this.onAddCompany}
            getCompanyNames={this.getCompanyNames}
            companyGroupNames={this.state.companyGroupNames}
          />
          <AddCompanyGroupModal
            isOpen={this.props.addCompanyGroupShow}
            onCancel={this.props.addCompanyGroupCancel}
            onConfirm={this.onAddCompanyGroup}
          />
          <AddEnterpriseGroupModal
            isOpen={this.props.addEnterpriseGroupShow}
            onCancel={this.props.addEnterpriseGroupCancel}
            onConfirm={this.onAddEnterpriseGroup}
          />
          <EditCompanyModal
            isOpen={this.props.editCompanyShow}
            onCancel={this.props.editCompanyCancel}
            onConfirm={this.editCompany}
          />
          {/* <EditCompanyGroupModal
            isOpen={this.props.editCompanyGroupShow}
            onCancel={this.props.editCompanyGroupCancel}

          /> */}
          <CustomModal
            header={`Company Group Management - ${editCompanyGroupData?.name}`}
            isOpen={this.props.editCompanyGroupShow}
            // onConfirm={onReleasePublish}
            hideFooter
            wider
          >
            <CompanyGroupManagement
              onConfirm={this.editCompanyGroup}
              onCancel={this.props.editCompanyGroupCancel}
            />
          </CustomModal>
          <CustomModal
            header={'Enterprise Group Management - Granite'}
            isOpen={this.props.editEnterpriseGroupShow}
            // onConfirm={onReleasePublish}
            hideFooter
            wider
          >
            <EnterpriseGroupManagement
              onConfirm={this.editEnterpriseGroup}
              onCancel={this.props.editEnterpriseGroupCancel}
            />
          </CustomModal>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  companyGroupDropdownList: state.AppState.companyGroupListDropdown,
  user: state.AppState.user,
  companiesList: state.AppState.companiesList,
  deleteCompanyShow: state.UIState.companies.deleteCompanyShow,
  deleteEnterpriseShow: state.UIState.companies.deleteEnterpriseShow,
  addCompanyShow: state.UIState.companies.addCompanyShow,
  addCompanyGroupShow: state.UIState.companies.addCompanyGroupShow,
  addEnterpriseGroupShow: state.UIState.companies.addEnterpriseGroupShow,
  editEnterpriseGroupData: state.UIState.companies.editEnterpriseGroupData,
  editCompanyShow: state.UIState.companies.editCompanyShow,
  editCompanyGroupShow: state.UIState.companies.editCompanyGroupShow,
  editEnterpriseGroupShow: state.UIState.companies.editEnterpriseGroupShow,
  deleteCompanyID: state.UIState.companies.deleteCompanyID,
  deleteEnterpriseID: state.UIState.companies.deleteEnterpriseID,
  companiesLoading: state.UIState.companies.companiesLoading,
  addedCompany: state.UIState.companies.addedCompany,
  addedCompanyGroup: state.UIState.companies.addedCompanyGroup,
  editCompanyData: state.UIState.companies.editCompanyData,
  editCompanyGroupData: state.UIState.companies.editCompanyGroupData,
  companyFilter: state.UIState.epikBoxes.companyFilter,
  addCompanyGroupChange: state.UIState.companies.addCompanyGroupChange,
  addEnterpriseGroupChange: state.UIState.companies.addEnterpriseGroupChange,
  deleteMode: state.AppState.deleteMode,
});

const mapDispatchToProps = dispatch => ({
  getAllCompaniesByGroup: (token, groupID) =>
    dispatch(getAllCompaniesByGroupAction(token, groupID)),
  getCompanyGroupDropdownList: (token, pagination, paginateResult) =>
    dispatch(getAllCompanyGroups(token, pagination, paginateResult)),
  onRecoverCompanyGroup: (token, id) => dispatch(onRecoverCompanyGroup(token, id)),
  onRecover: (token, id) => dispatch(onRecover(token, id)),
  getCompanies: (token, pagination, disablePaginate, type, getDeleted) =>
    dispatch(getCompanies(token, pagination, disablePaginate, type, getDeleted)),
  getAllCompanyGroups: (token, pagination) => dispatch(getAllCompanyGroups(token, pagination)),
  filterCompanies: (token, company, pagination) =>
    dispatch(filterCompanies(token, company, pagination)),
  showEditCompany: id => dispatch(showEditCompany(id)),
  showEditCompanyGroup: data => dispatch(showEditCompanyGroup(data)),
  showEditEnterpriseAdmin: id => dispatch(showEditEnterpriseAdmin(id)),
  editCompanyCancel: () => dispatch(cancelEditCompany()),
  editCompanyGroupCancel: () => dispatch(cancelEditCompanyGroup()),
  editEnterpriseGroupCancel: () => dispatch(cancelEditEnterpriseAdmin()),
  editCompany: (token, id, company) => dispatch(updateCompany(token, id, company)),
  editCompanyGroup: (token, id, company) => dispatch(updateCompanyGroup(token, id, company)),
  editEnterpriseGroup: (token, company) => dispatch(updateEnterpriseAdmin(token, company)),
  showAddCompany: () => dispatch(showAddCompany()),
  showAddCompanyGroup: () => dispatch(showAddCompanyGroup()),
  showAddEnterpriseGroup: () => dispatch(showAddEnterpriseGroup()),
  addCompanyCancel: () => dispatch(cancelAddCompany()),
  addCompanyGroupCancel: () => dispatch(cancelAddCompanyGroup()),
  addEnterpriseGroupCancel: () => dispatch(cancelAddEnterpriseGroup()),
  addCompany: (token, company) => dispatch(addCompany(token, company)),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
  addCompanyGroup: (token, company) => dispatch(addCompanyGroup(token, company)),
  addEnterpriseGroup: (token, company) => dispatch(addEnterpriseGroup(token, company)),
  deleteCompany: (token, id) => dispatch(deleteCompany(token, id)),
  deleteCompanyGroup: (token, id, hardDelete) =>
    dispatch(deleteCompanyGroup(token, id, hardDelete)),
  showDeleteCompany: id => dispatch(showDeleteCompany(id)),
  showDeleteEnterprise: id => dispatch(showDeleteEnterprise(id)),
  cancelDeleteCompany: () => dispatch(cancelDeleteCompany()),
  cancelDeleteEnterprise: () => dispatch(cancelDeleteEnterprise()),
  setCompanyStatus: (token, id, status) => dispatch(setCompanyStatus(token, id, status)),
  getBoxCount: (token, companyID) => dispatch(getBoxCount(token, companyID)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Companies));